// extracted by mini-css-extract-plugin
export default {"icon":"styles_icon__Gv5b-","footer":"styles_footer__-0+d-","container":"styles_container__YMVAc"};